/*
  assets/footer-main.js
  Phone accordions for sections/footer-main.liquid (#289).

  Each collapsible Footer column renders its heading once, as an <h2> holding a
  button (blocks/footer-column.liquid). Below 768px that button opens and closes
  the column; above it the button is inert and the heading reads as a plain
  heading. The column's content is never removed or fetched, only hidden with
  CSS, so every footer link is in the HTML for crawlers either way.
*/
if (!customElements.get('footer-main')) {
  customElements.define(
    'footer-main',
    class FooterMain extends HTMLElement {
      connectedCallback() {
        if (this.query) return;
        // 767 matches the phone breakpoint in assets/footer-main.css.
        this.query = window.matchMedia('(max-width: 767px)');
        this.onClick = this.onClick.bind(this);
        this.sync = this.sync.bind(this);
        this.addEventListener('click', this.onClick);
        this.query.addEventListener('change', this.sync);
        this.sync();
      }

      disconnectedCallback() {
        if (!this.query) return;
        this.removeEventListener('click', this.onClick);
        this.query.removeEventListener('change', this.sync);
        this.query = null;
      }

      // The toggle is a real control only where columns collapse, so it is
      // only focusable, and only reports expanded/collapsed, there.
      sync() {
        const phone = this.query.matches;
        this.querySelectorAll('.footer-column__toggle').forEach((button) => {
          const column = button.closest('.footer-column');
          const active = phone && column.classList.contains('footer-column--collapsible');
          button.tabIndex = active ? 0 : -1;
          if (active) button.setAttribute('aria-expanded', String(column.classList.contains('is-open')));
          else button.removeAttribute('aria-expanded');
        });
      }

      onClick(event) {
        if (!this.query.matches) return;
        const button = event.target.closest('.footer-column__toggle');
        if (!button || !this.contains(button)) return;
        const column = button.closest('.footer-column');
        if (!column.classList.contains('footer-column--collapsible')) return;
        const open = !column.classList.contains('is-open');
        column.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        this.dispatchEvent(new CustomEvent('footer-main:toggle', { bubbles: true, detail: { id: column.id, open } }));
      }
    }
  );
}
